<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay">
      <div class="modal-window" style="width: 352px;">
        <div class="hw-modal-wrap modal-content">
          <div class="hw-modal-header">{{ $t('ORDER_SET_TITLE') }}</div>

          <div class="hw-modal-body">
            <div
              ref="menuSort"
              class="ui-sortable office_home_body"
              style="max-height: 250px; overflow-y: auto; overflow-x: hidden;"
            >
              <div
                class="edit_oder_sortable approval-sortable-group"
                v-for="menuInfo in isVisibleMenuInfoList"
                :key="menuInfo.menu_type"
                v-bind:data-id="menuInfo.menu_type"
              >
                <div class="group-head">
                  <div class="group-btn-handle"><i class="gis gi-grab"></i></div>
                  <span v-html="menuInfo.icon"></span>
                  <div class="label-name">{{ menuInfo.name }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="hw-modal-footer">
            <button type="button" class="hw-button secondary" @click="close">{{ $t('CLOSE') }}</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Sortable from 'sortablejs';

export default {
  name: 'MenuOrderSetting.vue',
  props: {
    menuInfoList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isVisibleMenuInfoList() {
      return this.menuInfoList.filter((menuInfo) => {
        return menuInfo.is_use;
      });
    },
  },
  mounted() {
    let self = this;
    let menuSort = this.$refs.menuSort;
    let sortable = Sortable.create(menuSort, {
      animation: 250,
      maxLevels: 0,
      onEnd: function() {
        self.modifyMenuOrder(sortable.toArray());
      },
    });
  },
  methods: {
    modifyMenuOrder(menuTypeList) {
      this.$emit('modify-menu-order', menuTypeList);
    },
    close() {
      this.$emit('set-is-menu-order-setting-visible', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/style';

.hw-button {
  display: inline-block;
  background-color: $primary-color;
  border: 1px solid $primary-color-hover;
  border-radius: 4px;
  color: #fff;
  padding: 5px 20px 6px;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  transition-duration: 0.1s;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;

  //hover
  &:hover,
  &:focus {
    color: #fff;
    background: darken($primary-color-hover, 10%);
    border-color: darken($primary-color-hover, 10%);
    outline: none;
  }

  //disabled
  &[disabled],
  &:disabled {
    cursor: default;
    opacity: 0.5;
    &:hover {
      background: $primary-color;
      border-color: $primary-color-hover;
    }
  }

  &.secondary {
    background-color: $secondary-color;
    border-color: $secondary-color-hover;
    color: #333;
    &:hover,
    &:focus {
      background-color: $secondary-color-hover;
      border-color: $secondary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $secondary-color;
        border-color: $secondary-color-hover;
      }
    }
  }

  &.info {
    background-color: $info-color;
    border-color: $info-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $info-color-hover;
      border-color: $info-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $info-color;
        border-color: $info-color-hover;
      }
    }
  }

  &.warning {
    background-color: $warning-color;
    border-color: $warning-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $warning-color-hover;
      border-color: $warning-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $warning-color;
        border-color: $warning-color-hover;
      }
    }
  }

  &.danger {
    background-color: $danger-color;
    border-color: $danger-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $danger-color-hover;
      border-color: $danger-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $danger-color;
        border-color: $danger-color-hover;
      }
    }
  }

  &.text {
    color: $primary-color;
    padding: 0 10px;
    background: transparent;
    border-color: transparent;
    //hover
    &:hover,
    &:focus {
      color: $primary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        color: $primary-color;
        background: transparent;
        border-color: transparent;
        opacity: 0.5;
      }
    }
  }

  &.outline-blue {
    background-color: #fff;
    border: 1px solid #c8c8c8;
    color: #2c86dc;
    &:hover {
      border-color: #2c86dc;
    }
  }

  &.outline-gray {
    background: #f1f1f1;
    border: 1px solid #c8c8c8;
    color: #444;
    &:hover {
      border-color: #8c8c8c;
    }
  }

  &.outline-gray2 {
    background: #fff;
    border: 1px solid #d6d6d6;
    color: #333;
    padding-left: 12px;
    padding-right: 12px;
    > i {
      color: #909090;
      float: right;
      margin-top: 4px;
      margin-left: 10px;
    }
    &:hover {
      background: #f6f6f6;
    }
    &:focus {
      > i {
        color: #575757;
      }
    }
    &[disabled],
    &:disabled {
      border-color: #f2f2f2;
      background: #ffffff;
      &,
      > i {
        color: #d0d0d0;
      }
    }
  }

  &.rounded {
    border-radius: 4px;
  }

  //이웃하는 버튼 간격
  & + .hw-button {
    margin-left: 14px;
  }
}

.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
  }

  &-window {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  &-content {
    padding: 10px 20px;
  }

  &-footer {
    background: #ccc;
    padding: 10px;
    text-align: right;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s;

  .modal-window {
    transition: opacity 0.2s, transform 0.2s;
  }
}

.modal-leave-active {
  transition: opacity 0.2s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.hw-modal-header {
  padding-bottom: 20px;
  border-bottom: 1px solid #d6d6d6;
  font-size: 16px;
}

.hw-modal-body {
  padding-top: 20px;
  font-size: 14px;
  max-height: 580px;
  overflow-y: auto;
}

.hw-modal-footer {
  padding-top: 30px;
  text-align: center;
}
// 전자결재 유니버셜 결재선: 순서 변경 UI

// common
$universalSortableStepsWidth: 30px;
$universalSortableTableHeadWidth: 118px;
$universalSortableCellWidth: 150px;
$universalSortableCellHeight: 46px;
$universalSortableCellBackgroundDisabled: #fbfbfb;
$universalSortableRowBorderColor: #ebebeb;
$universalStepSize: 16px;

@import 'src/assets/scss/mixins/clearfix';

@mixin truncate($truncation-boundary: inherit) {
  display: inline-block;
  max-width: $truncation-boundary;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@mixin truncateFlexChild() {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@mixin universalSortableItem($placeholderColor: #2c86dc) {
  // drag handle
  .btn-handle {
    display: inline-block;
    visibility: hidden;
    cursor: move; // IE fallback
    cursor: grab;
    cursor: -webkit-grab;
    padding: 10px 2px;
    color: #999;
    &:hover {
      color: #333;
    }
  }

  // 드래그 중인 영역
  &.ui-sortable-helper {
    width: 100%;
    opacity: 0.6;
    cursor: grabbing;
    cursor: -webkit-grabbing;
  }
  // 가상 드롭 영역
  &.ui-sortable-placeholder {
    visibility: visible !important;
    box-sizing: border-box;
    width: $universalSortableCellWidth;
    height: 1px;
    background: $placeholderColor;
    display: block;
  }
}

// 결재선 묶음 삭제 버튼
.btn-delete-row {
  visibility: hidden;
  transform: translateX(-7px) scale(0.5);

  &.hw-icon > i {
    color: #333;
  }
}

// 개별 멤버 삭제 버튼
.btn-delete-cell {
  &.hw-icon > i {
    color: #333;
  }
}

.approval-sortable-group {
  @include universalSortableItem();
  display: flex;
  width: 100%;
  overflow: hidden;
  border: 1px solid #fff;
  border-bottom-color: $universalSortableRowBorderColor;
  &:not(.disabled):hover {
    border-color: #2985db;
    border-radius: 2px;
    .btn-delete-row {
      visibility: visible;
    }
  }

  // 드래그 중인 영역
  &.ui-sortable-helper {
    background: #f5f8fd;
    border-bottom: 0;
    border: 1px solid $universalSortableRowBorderColor;
  }

  // 가상 드롭 영역
  &.ui-sortable-placeholder {
    width: 100%;
    height: 1px;
    margin: 5px 0;
    border: 0;
  }

  // drag handle
  .group-btn-handle {
    color: #676767;
    margin-right: 4px;
  }

  .group-steps {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: $universalSortableStepsWidth;
    flex: 0 0 $universalSortableStepsWidth;
    border-right: 1px solid $universalSortableRowBorderColor;
    .step {
      display: inline-block;
      color: #fff;
      width: $universalStepSize;
      height: $universalStepSize;
      line-height: $universalStepSize + 1px;
      font-size: 12px;
      text-align: center;
      border-radius: 50%;
      background: #bec2c5;
    }
  }

  .group-head {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 0 0 100%;
    width: $universalSortableTableHeadWidth;
    min-height: 40px;
    font-size: 14px;
    color: #333;
  }

  .label-name {
    flex: 1 1 0;
    -ms-flex: 1 1 auto;
    margin-left: 8px;
  }

  // disabled 아닌 경우에만 스타일 적용
  &:not(.disabled) {
    .group-steps:hover {
      cursor: move; // IE fallback
      cursor: grab;
      cursor: -webkit-grab;
      & + .group-head .group-btn-handle {
        visibility: visible;
      }
    }
    .group-head:hover {
      cursor: move; // IE fallback
      cursor: grab;
      cursor: -webkit-grab;
      .group-btn-handle {
        visibility: visible;
      }
    }
  }

  // disabledd된 row
  &.disabled {
    background: $universalSortableCellBackgroundDisabled;
    select,
    select[disabled] {
      background: $universalSortableRowBorderColor !important;
      color: #c4c4c4 !important;
    }
  }
}

.approval-sortable-table {
  padding: 8px 0;

  // cell
  .approval-sortable-cell {
    @include universalSortableItem();
    display: flex;
    align-items: center;
    width: $universalSortableCellWidth;
    height: $universalSortableCellHeight;
    background-color: #f6f6f6;
    border: 1px solid #f6f6f6;
    border-radius: 2px;

    // disabled 아닌 경우에만 스타일 적용
    &:not(.disabled):hover {
      border-color: #2985db;
      cursor: move; // IE fallback
      cursor: grab;
      cursor: -webkit-grab;
      .row-btn-handle,
      .btn-delete-cell,
      .hw-icon {
        visibility: visible;
      }
    }

    &.no-handle {
      .row-btn-handle {
        visibility: hidden !important;
      }
    }

    // disabledd된 cell
    &.disabled {
      background: $universalSortableCellBackgroundDisabled;
      border: 0;
      .cell-column {
        .title,
        .description {
          color: #8f8f8f;
        }
      }
    }

    // 셀 내부 레이아웃
    .cell-column {
      // btn-handle 영역
      &:nth-child(1) {
        flex: 0 0 20px;
        text-align: center;
      }
      // 텍스트 영역
      &:nth-child(2) {
        flex: 1 1 0;
        -ms-flex: 1 1 auto;
        @include truncateFlexChild();
      }

      // 삭제버튼 영역
      &:nth-child(3) {
        align-self: flex-start;
        transform: scale(0.5);
        position: relative;
        top: -2px;
        left: 2px;
      }

      .title {
        font-size: 14px;
        color: #333;
        @include truncate();
        display: block;
      }
      .description {
        margin-top: 4px;
        font-size: 12px;
        width: 100%;
        @include truncate();
        display: block;
      }
      .hw-icon {
        width: 32px;
        height: 32px;
        padding: 0;
        visibility: hidden;
        color: #a8a8a8;
      }
    }
  }

  // 세로형 배열 (재무합의만)
  &:not(.horizontal) {
    .approval-sortable-cell {
      & + .approval-sortable-cell {
        margin-right: 7px;
        margin-top: 5px;
      }
      // &:last-of-type {
      //   float: left;
      // }
      // 가상 드롭 영역
      &.ui-sortable-placeholder {
        border: 0;
      }
    }
  }

  // 가로(카드형)
  &.horizontal {
    @include clearfix();
    .approval-sortable-cell,
    .disabled {
      float: left;
    }
    .approval-sortable-cell {
      margin-right: 7px;
      margin-bottom: 5px;
      // 가상 드롭 영역
      &.ui-sortable-placeholder {
        width: 1px;
        height: $universalSortableCellHeight;
        border: 0;
        margin: 0 -4px;
      }
    }
  }
}
.edit_oder_sortable {
  border: none;
}
</style>
